module.exports = __webpack_public_path__ + "img/電気回路_3_2_1.2d1df599.png";